export default __webpack_public_path__ + "static/media/home3.4c05727b.png";